'use client';

import { getUiConfig } from '@/config/client/getUiConfig';
import { type BrazeFunctions, useBraze } from '@/features/analytics/braze/hooks/useBraze';
import { useUserInfo } from '@/features/auth/hooks/useUserInfo';

export function useBrazeInstance(): BrazeFunctions {
  const { brazeApiKey, brazeEndpoint, isBrazeLoggingEnabled } = getUiConfig();
  const { profileId } = useUserInfo();

  return useBraze({ brazeApiKey, brazeEndpoint, isBrazeLoggingEnabled }, profileId);
}
